import React from "react";
import BaseComponent from "../../../baseComponent.js";
import FormulaBar from "./formulaBar.jsx";
import AppConfig from "../../../../config/config.js";
import styles from "./styles.scss";

import WidgetService from '../../../../core/services/widgetService';
import InternalEvent from "../../../../core/constants/internalEvent";

export default class Expression extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      error: this.getError()
    };
    this.subscribe(InternalEvent.Dashboard.ADD_WIDGET_UPDATED, () => {
      this.setState({
        error: this.getError()
      });
    });
  }

  componentWillUnmount() {
    this.unsubscribeAll();
  }

  getError() {
    const widget = WidgetService.getWidget(this.props.widgetId);
    const legend = widget ? widget.legends.find(l => l.id === this.props.legendId) : null;
    return legend ? legend.errors[this.props.expressionKey] : null;
  }

  render() {
    return (
      <div className={styles.configLineWrapper} ref="container">
        <div className={styles.configLine}>
          <div className={styles.configLabel}>{this.props.label}
            {
              this.state.error ?  <i className="material-icons">warning</i> : null
            }
          </div>

          <FormulaBar colors={AppConfig.EXTENDED_LEGEND_COLORS.slice()}
                      error={this.state.error}
                      expressionKey={this.props.expressionKey}
                      updateExpression={this.props.onLegendChange}
                      expression={this.props.expression}
                      mappings={this.props.mappings}
                      callback={this.props.callback}
                      dashboardVariables={this.props.dashboardVariables}
                      indexValue={this.props.indexValue}/>

        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/expression.jsx